import { render, staticRenderFns } from "./Invitations.vue?vue&type=template&id=f7bc436e&scoped=true&"
import script from "./Invitations.vue?vue&type=script&lang=js&"
export * from "./Invitations.vue?vue&type=script&lang=js&"
import style0 from "./Invitations.vue?vue&type=style&index=0&id=f7bc436e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bc436e",
  null
  
)

export default component.exports